import type { Mission } from '../missions.ts'

export const nhtsa: Mission = {
  id: "nhtsa",
  name: "National Highway Traffic Safety Administration",
  short: "NHTSA",
  call: "Road Safety",
  kind: "subagency",
  parent: "dot",
  url: "https://www.nhtsa.gov/",
  established: 1970,
  palette: {
    primary: "#0075b7",
    secondary: "#13386e",
    accent: "#bf1e2d",
  },
  colorSource: {
    kind: "site",
    url: "https://www.nhtsa.gov/",
  },
  motif: "car",
  mission: {
    text: "The National Highway Traffic Safety Administration is responsible for keeping people safe on America’s roadways.",
    url: "https://www.nhtsa.gov/about-nhtsa",
  },
  fact: {
    text: "NHTSA was established within DOT by the Highway Safety Act of 1970, enacted on December 31, 1970.",
    url: "https://www.archives.gov/research/guide-fed-records/groups/416.html",
  },
  logo: {
    file: "public/logos/nhtsa.svg",
    source: "https://commons.wikimedia.org/wiki/File:National_Highway_Traffic_Safety_Administration_logo.svg",
  },
  identifier: {
    about: "https://www.nhtsa.gov/about-nhtsa",
    accessibility: "https://www.nhtsa.gov/about-nhtsa/accessibility",
    foia: "https://www.nhtsa.gov/about-nhtsa/foia",
    noFear: "https://www.transportation.gov/civil-rights/civil-rights-awareness-enforcement/no-fear-act",
    oig: "https://www.oig.dot.gov/",
    performance: "https://www.nhtsa.gov/about-nhtsa/nhtsa-budget-information",
    privacy: "https://www.nhtsa.gov/about-nhtsa/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/nhtsa-frontal-test.jpg",
        small: "/media/nhtsa-frontal-test-sm.jpg",
        alt: "A white pickup truck with a crumpled front end and deployed airbags after a frontal crash test, marked with yellow test targets.",
        title: "Ford F-150 Crew Cab frontal crash test",
        creator: "Calspan Corporation for the National Highway Traffic Safety Administration",
        source: "https://commons.wikimedia.org/wiki/File:Ford_F-150_Crew_Cab_Frontal_Crash_Test.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/nhtsa-side-test.jpg",
        small: "/media/nhtsa-side-test-sm.jpg",
        alt: "A red moving barrier striking the side of a silver sedan under bright lights in a crash test laboratory.",
        title: "Side impact crash test, NHTSA New Car Assessment Program",
        creator: "Calspan Corporation for the National Highway Traffic Safety Administration",
        source: "https://commons.wikimedia.org/wiki/File:V09727P441.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
